var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","color":this.color,"right":this.right,"absolute":this.absolute},on:{"click":_vm.onClick}},[_c('v-icon',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }